import {useDiaryStore} from 'entities/diary';
import {useHivesStore} from 'entities/hives';
import {useUserStore} from 'entities/user';
import {useApiariesStore} from '../../../entities/apiaries';

export const useDiary = () => {
  const hives = useHivesStore((s) => s.hives);
  const currentApiary = useApiariesStore((s) => s.currentApiary());
  const userInfo = useUserStore((state) => state.userInfo);
  const entries = useDiaryStore((s) => s.entries);
  const setIsNewEntrieOpen = useDiaryStore((s) => s.setIsNewEntrieOpen);

  return {
    hives,
    userInfo,
    entries,
    setIsNewEntrieOpen,
    currentApiary,
  };
};
